import { render, staticRenderFns } from "./make-invoice.vue?vue&type=template&id=0fdf6527&scoped=true&"
import script from "./make-invoice.vue?vue&type=script&lang=ts&"
export * from "./make-invoice.vue?vue&type=script&lang=ts&"
import style0 from "./make-invoice.vue?vue&type=style&index=0&id=0fdf6527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf6527",
  null
  
)

export default component.exports